// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import router from './router'
import store from './store'
import underscore from 'vue-underscore'
import vuetify from './plugins/vuetify'
import ObserveVisibility from './plugins/visibleObserver'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

// if ('serviceWorker' in navigator) {
//   // Use the window load event to keep the page load performant
//   window.addEventListener('load', () => {
//     navigator.serviceWorker
//       .register('../dist/service-worker.js')
//       .then(reg => {
//         // registration worked
//         console.log('Registration succeeded. Scope is ' + reg.scope)
//       })
//       .catch(error => {
//         // registration failed
//         console.log('Registration failed with ' + error)
//       })
//   })
// }

if (process.env.SENTRY_DSN) {
  Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [
      new Integrations.BrowserTracing({
        // routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', process.env.DOMAIN_NAME, /^\//]
      })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1
  })
}

Vue.config.productionTip = false

new Vue({
  // router,
  store,
  underscore,
  ObserveVisibility,
  vuetify,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js